export const alertStyles = {
  loading: {
    container: "bg-[#F5F0E9] border-[#EBE4D8]",
    text: "text-gray-900",
    icon: "text-orange-700",
  },
  success: {
    container: "bg-[#EEFCEF] border-[#99C2AC]",
    text: "text-gray-900",
    icon: "text-[#016630]",
  },
  error: {
    container: "bg-[#FFEBEB] border-[#C54444]",
    text: "text-gray-900",
    icon: "text-[#C54444]",
  },
  warning: {
    container: "border-orange-200 bg-orange-50",
    text: "text-orange-700",
    icon: "text-orange-700",
  },
  info: {
    container: "border-[#EBE4D8] bg-[#F5F0E9]",
    text: "text-gray-900",
    icon: "text-[#574921]",
  },
  infoBlue: {
    container: "border-[#9CADD9] bg-[#E8F0FB] text-gray-900",
    text: "text-gray-900",
    icon: "text-[#07329F]",
  },
} as const;

export type AlertType = keyof typeof alertStyles;

export interface AlertStyleConfig {
  container: string;
  text: string;
  icon: string;
}

export const getAlertStyles = (type: AlertType): AlertStyleConfig => {
  return alertStyles[type];
};

export const alertSizeClasses = {
  compact: "p-3",
  default: "p-4",
  large: "p-5",
} as const;

export const alertBorderRadius = "rounded-[16px]";

export const buildAlertClasses = (
  type: AlertType,
  size: keyof typeof alertSizeClasses = "default",
  additionalClasses?: string,
): string => {
  const styles = getAlertStyles(type);
  return [
    "border",
    alertBorderRadius,
    styles.container,
    styles.text,
    alertSizeClasses[size],
    additionalClasses,
  ]
    .filter(Boolean)
    .join(" ");
};
